




















import {
  DynamicDocumentData,
  DynamicDocumentGroup,
  InstallationModule,
  InstallationModuleData,
  MechanicInstallation,
} from '@/types';
import Vue, { PropType } from 'vue';

import DocumentGroup from './DocumentGroup.vue';

import eventbus from '@/utilities/eventbus';

export default Vue.extend({
  components: {
    DocumentGroup,
  },

  props: {
    document: {
      type: Array as PropType<DynamicDocumentGroup[]>,
      default: () => [],
    },

    data: {
      type: Array as PropType<DynamicDocumentData>,
      default: () => [],
    },

    /**
     * Show a per-section done/open marker in the header. Off by default: the installation delivery
     * documents have shipped without one for years and their headers already carry other state.
     */
    showStatus: {
      type: Boolean,
      default: false,
    },

    moduleData: {
      type: Object as PropType<InstallationModuleData>,
    },

    module: {
      type: Object as PropType<InstallationModule>,
    },

    installation: {
      type: Object as PropType<MechanicInstallation>,
    },

    // When set, every group panel starts expanded (used by flat single-group
    // forms like the service questionnaire instead of the collapsed default).
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    eventbus.$on('expand:open', this.onExpandOpen);

    if (this.defaultExpanded) {
      this.activePanels = this.document.map((_group, i) => i);
    }
  },

  destroyed() {
    eventbus.$off('expand:open', this.onExpandOpen);
  },

  methods: {
    onExpandOpen(index: number) {
      if (!this.activePanels.includes(index)) {
        this.transition = false;
        this.$nextTick(() => this.activePanels.push(index));
        setTimeout(() => (this.transition = true), 300);
      }
    },
  },

  data() {
    return {
      activePanels: [] as number[],
      transition: true,
    };
  },
});
